import React from "react";
import { FaXTwitter, FaFacebookF, FaInstagram } from "react-icons/fa6";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a
              href="https://x.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (formerly Twitter)"
            >
              <FaXTwitter />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h3>Contact Info</h3>
          <p>Serbia, Belgrade</p>
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:info@yourcompany.com"
              style={{ color: "var(--TEXTCOLOR)" }}
            >
              m.stankovic005@gmail.com
            </a>
            <br />
            <strong>Phone:</strong>{" "}
            <a href="tel:+1234567890" style={{ color: "var(--TEXTCOLOR)" }}>
              +381 656 120 150
            </a>
          </p>
        </div>

        <div className="footer-column">
          <h3>Company</h3>
          <ul className="company-links">
            <li>
              <a href="/about">UManage, 2025.</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
